import { useState, useContext, useEffect, useRef } from 'react';
import LearnLesson from './LessonPage';
import { XAPIService } from '@/services/xapi.service';
import Cmi5, { LaunchParameters } from '@xapi/cmi5';
import {
  parseJwt,
  useStateAndRef,
  useTraceUpdate,
  parseQueryString,
} from '@/util';
import { NavContext } from '@/components/NavContext';
import { axios } from '@/axios';
import { config } from '@/config';
import { useNavigate, useMatches, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { encode } from '@/base64';
import XAPI from '@xapi/xapi';
import { Spinner } from '@teo/components';

//this component will login with the actor parameter and then redirect
//Compatible with Scorm/Alu duffel launch/Lti launch
function Launch() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const queries: any = parseQueryString(document.location.search);

    const simplified: any = {
      actor: queries.actor,
      token: queries.token,
      ltitoken: queries.ltitoken,
    };

    if (!queries.actor) {
      setTimeout(
        () =>
          navigate(
            `/${i18n.language}/error?error=${encode(
              JSON.stringify({ message: 'Missing actor query parameter' })
            )}`
          ),
        0
      );
      return;
    }

    axios
      .post(config.teologin + '/xapi', simplified, {
        withCredentials: true,
      })
      .then((result) => {
        const redirectUrl = new URL(window.location.href);

        const redirect_uri = new URL(
          redirectUrl
            .toString()
            .replace(/\/scorm/, '/lesson')
            .replace(/\/start/, '/lesson')
            .replace(/\/lti/, '/lesson')
        );

        redirect_uri.search = ''; // 🔥 Strip all query params

        // Add `lti=true` to final redirect_uri if applicable
        if (simplified.ltitoken) {
          redirect_uri.searchParams.set('lti', 'true');
          redirect_uri.searchParams.set('skipconsent', 'true');
        }

        const logintoken = result.data.token;
        const path = `${config.backend}/auth?idp=local&lang=${
          i18n.language
        }&redirect_uri=${encodeURIComponent(
          redirect_uri.toString()
        )}&logintoken=${logintoken}`;

        window.location.replace(path);
      })
      .catch((e) => {
        console.error(e);
        const error = {
          status: 'launch_login_failed',
          message:
            'Login failed during launch. Please try again or contact support.',
        };
        setTimeout(
          () =>
            navigate(
              `/${i18n.language}/error?error=${encode(JSON.stringify(error))}`
            ),
          0
        );
        return;
      });
  }, []);

  return null;
}

export default Launch;
